import React from "react";

import { Box, Chip, Stack, TextField, Typography } from "@mui/material";
import { InputCustom } from "../ui-elements/input-ui";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { PetitionProps, PetitionPropsOne } from "../../interface/posts";
import { tip_data } from "./data";

const PetitionOne = ({
  next,
  cancel,
  petition_data,
  setPetition_data,
}: PetitionPropsOne) => {
  const handle_next = () => {
    next();
  };
  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          height: "4px",
          background: "url(/assets/icons/posts/line-01.png)",
        }}
      />

      <Stack sx={{ mt: 3, px: 2 }}>
        <Typography
          color="black"
          variant="body2"
          sx={{
            fontSize: 15,
            fontWeight: 500
          }}
        >
          Write your petition title
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#7991A4",
          }}
        >
          Tell people what you want to change
        </Typography>
      </Stack>
      <Stack sx={{ my: 2, px: 2 }}>
        <Typography
          variant="caption"
          sx={{
            color: "#7991A4",
          }}
        >
          Petition title
        </Typography>
        <InputCustom
          placeholder={""}
          value={petition_data?.title}
          onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setPetition_data(prev => ({...prev, title: e.target.value}))
          }}
          type={""}
          styles={undefined}
          size={undefined}
        />
      </Stack>
      <Stack sx={{ px: 2 }} direction={"row"} justifyContent={"flex-end"}>
        <Chip
          label="Cancel"
          onClick={() => cancel()}
          sx={{
            backgroundColor: "#92A5B5",
            color: "#fafafa",
            mx: 1,
          }}
        />
        <Chip
          label="Continue"
          onClick={handle_next}
          color="primary"
          sx={{
            color: "#fafafa",
            px: 1,
          }}
        />
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <FiberManualRecordIcon sx={{ color: "#459173", fontSize: 10 }} />
        <FiberManualRecordIcon sx={{ color: "#C2CDD6", fontSize: 10 }} />
        <FiberManualRecordIcon sx={{ color: "#C2CDD6", fontSize: 10 }} />
      </Box>
      <Box
        sx={{
          backgroundColor: "#FAFbFc",
          py: 3,
          px: 2,
          borderRadius: 8,
        }}
      >
        <Typography variant="caption" color="black">
          Tips
        </Typography>
        {tip_data?.map((val, id) => (
          <Box
            key={id}
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: 3,
            }}
          >
            <FiberManualRecordIcon
              sx={{ color: "#000", fontSize: 8, mt: "4px" }}
            />
            <Box style={{ marginBottom: 8, width: "98%" }}>
              <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                {val.main}
              </Typography>
              <Typography sx={{ fontSize: "13px" }}>{val.content}</Typography>
              <Typography sx={{ fontSize: "13px" }}>{val.example}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PetitionOne;
